import { apiSlice } from '..';
import { DebugData } from '../generated';

const debugsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDebugData: builder.query<DebugData, void>({
            query: () => 'debug',
        })
    })
});

export const { useGetDebugDataQuery } = debugsSlice;
export default debugsSlice;
